<div class="sidebar-header">
  <a class="b-brand">
    <div class="logo">
      <img class="logo-image" [src]="logoImageUrl" alt="Logo Image" />
    </div>
    <div class="sidebar-header__info">
      <span class="b-title">{{companyName}}</span>
    </div>
  </a>
</div>